import { LibraryItemTypes } from '../store/enums'

export const LibraryItemUrl = {
  [LibraryItemTypes.DELIVERABLE]: 'deliverable',
  [LibraryItemTypes.COMPONENT]: 'component',
  [LibraryItemTypes.THIRD_PARTY_COST]: 'third-party-cost',
}
